module.exports = __webpack_public_path__ + "static/media/icon-upvote-outline.a1f1a2da.svg";